var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidateNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 32C24.8231 32 32 24.8221 32 16C32 7.17787 24.8231 0 16.0004 0C7.17766 0 0 7.17748 0 16C0 24.8225 7.17766 32 16.0004 32ZM16.0004 30.1457C12.0506 30.1457 8.47545 28.5167 5.90691 25.8977C7.32073 23.8556 11.3039 22.3834 16 22.3834C20.6965 22.3834 24.6801 23.8552 26.0939 25.8973C23.5245 28.5167 19.9494 30.1457 16.0004 30.1457ZM23.6449 12.4947C23.6449 16.7169 20.223 20.1398 16 20.1398C11.7781 20.1398 8.35512 16.7173 8.35512 12.4947C8.35512 8.27221 11.7781 4.84966 16 4.84966C20.2226 4.84966 23.6449 8.27221 23.6449 12.4947Z",
    fill: "#94ACF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateNoImage);
export default __webpack_public_path__ + "static/media/candidate-no-image.61533ee72a9f3126e7e54a6c11198259.svg";
export { ForwardRef as ReactComponent };